import { PayloadAction } from '@reduxjs/toolkit';
import { ICheckout } from '../../core/interfaces/ICheckout';

export const CheckoutReducer = {
	initCheckout: (state: ICheckout, action: PayloadAction<ICheckout>) => {
		state.admin_email = action.payload.admin_email;
		state.admin_name = action.payload.admin_name;
		state.currency = action.payload.currency;
		state.currency_symbol = action.payload.currency_symbol;
		state.end_date = action.payload.end_date;
		state.gross_premium = action.payload.gross_premium;
		state.insurance_name = action.payload.insurance_name;
		state.installments = action.payload.installments;
		state.interest = action.payload.interest;
		state.iof = action.payload.iof;
		state.max_warranty_limit = action.payload.max_warranty_limit;
		state.plan = action.payload.plan;
		state.signer_email = action.payload.signer_email;
		state.signer_name = action.payload.signer_name;
		state.start_date = action.payload.start_date;
		state.total_premium = action.payload.total_premium;
	},

	setPaymentSummary: (state: ICheckout, action: PayloadAction<any>) => {
		state.iof = action.payload.iof;
		state.interest = action.payload.interest;
		state.total_premium = action.payload.total_premium;
		state.installments = action.payload.installments;
		state.installment_amount = action.payload.installment_amount;
		state.gross_premium = action.payload.gross_premium;
	},

	setStartDateAndEndDate: (state: ICheckout, action: PayloadAction<any>) => {
		state.start_date = action.payload.start_date;
		state.end_date = action.payload.end_date;
	},

	setSignerName: (state: ICheckout, action: PayloadAction<any>) => {
		state.signer_name = action.payload;
	},

	setSignerType: (state: ICheckout, action: PayloadAction<string>) => {
		state.signer_type = action.payload;
	},

	setSignerEmail: (state: ICheckout, action: PayloadAction<string>) => {
		state.signer_email = action.payload;
	},

	setAdminName: (state: ICheckout, action: PayloadAction<any>) => {
		state.admin_name = action.payload;
	},

	setAdminEmail: (state: ICheckout, action: PayloadAction<any>) => {
		state.admin_email = action.payload;
	},

	setMaxLimitWarranty: (state: ICheckout, action: PayloadAction<any>) => {
		state.max_warranty_limit = action.payload;
	},

	setInsuranceName: (state: ICheckout, action: PayloadAction<string>) => {
		state.insurance_name = action.payload;
	},

	setInsurerName: (state: ICheckout, action: PayloadAction<string>) => {
		state.insurer_name = action.payload;
	},

	toggleLoadingPaymentSection: (
		state: ICheckout,
		action: PayloadAction<boolean>
	) => {
		state.is_loading_payment_section = action.payload;
	},
};
